import { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'shared/hooks/useTranslation';

interface LanguageRedirectProps {
  children: ReactNode;
}

const LanguageRedirect = ({ children }: LanguageRedirectProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentLanguage } = useTranslation();

  useEffect(() => {
    const path = location.pathname;
    const segments = path.split('/').filter(Boolean);
    
    // If no language in URL, redirect to default language
    if (!segments[0] || !['es', 'en'].includes(segments[0])) {
      const currentPath = segments.length > 0 ? segments.join('/') : '';
      const newPath = `/${currentLanguage}${currentPath ? `/${currentPath}` : ''}${location.search}${location.hash}`;
      navigate(newPath, { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate, currentLanguage]);

  return <>{children}</>;
};

export default LanguageRedirect;
